import { createSlice } from "@reduxjs/toolkit";
import api from "../../services";
import { API_RESPONSE, PLAYMATEZAPI } from "../../services/apiConstant";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import axios from "axios";

const redirectToDashboard = () => {
  window.location.replace("/dashboard");
};

const getNormalizedEmail = (email) => (email || "").trim().toLowerCase();

const isSameStoredUser = (storedUser, nextUser) => {
  const storedEmail = getNormalizedEmail(storedUser?.data?.email);
  const nextEmail = getNormalizedEmail(nextUser?.data?.email);
  const hasMatchingEmail = storedEmail && nextEmail && storedEmail === nextEmail;
  const hasMatchingUserType =
    storedUser?.data?.userType == nextUser?.data?.userType;
  const hasMatchingId = storedUser?.data?.id == nextUser?.data?.id;

  return (
    (hasMatchingEmail && hasMatchingUserType) ||
    (hasMatchingId && hasMatchingUserType)
  );
};

const storeLoggedInUser = (result) => {
  const savedUsers =
    secureLocalStorage.getItem(process.env.REACT_APP_USERS_LIST_KEY) || [];
  const userListData = Array.isArray(savedUsers) ? [...savedUsers] : [];
  const existingIndex = userListData.findIndex((item) =>
    isSameStoredUser(item, result)
  );

  if (existingIndex === -1) {
    userListData.push(result);
  } else {
    userListData[existingIndex] = result;
  }

  secureLocalStorage.setItem(
    process.env.REACT_APP_USERS_LIST_KEY,
    userListData
  );
  secureLocalStorage.setItem(
    process.env.REACT_APP_TOKEN_STORAGE_KEY,
    result.token
  );
  secureLocalStorage.setItem(
    process.env.REACT_APP_USER_STORAGE_KEY,
    result.data
  );
};

const slice = createSlice({
  name: "auth",
  initialState: {
    userData: null,
    message: "",
    isLoading: false,
    eventData: null,
    otpToken: null,
    userExistingRoles: [],
    userExistingSubType: null,
    configData: null,
  },
  reducers: {
    apiFetching: (state) => {
      state.isLoading = true;
    },
    apiFailed: (state) => {
      state.isLoading = false;
    },
    setUserExistingRoles: (state, action) => {
      state.userExistingRoles = action.payload?.userType || action.payload?.userTypes;
      state.userExistingSubType = action.payload?.userTypeWithSubType || null;
    },
    setotpToken: (state, action) => {
      state.otpToken = action.payload?.otpToken;
    },
    getConfigSuccess: (state, action) => {
      state.configData = action.payload;
    },

    getNotificationListSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.notificationData = action.payload?.data;
      } else {
        state.notificationData.data = state.notificationData.data.concat(
          action.payload?.data?.data
        );
      }
    },
    addRatingReviewsSuccess: (state, action) => {
      let index = state.notificationData.data.findIndex(
        (item) => item?.id == action.payload
      );
      if (index != -1) {
        state.notificationData.data[index].isVenueRated = true;
      }
    },
    countMyUnreadNotificationSuccess: (state, action) => {
      state.notificationCount = action.payload;
    },
    deleteNotificationsSuccess: (state, action) => {
      state.notificationData.data = (state.notificationData?.data || []).filter(
        (item) => !action?.payload?.includes(item.id)
      );
    },
  },
});

export default slice.reducer;
const {
  apiFetching,
  apiFailed,
  setUserExistingRoles,
  setotpToken,
  getConfigSuccess,
  getNotificationListSuccess,
  addRatingReviewsSuccess,
  countMyUnreadNotificationSuccess,
  deleteNotificationsSuccess,
} = slice.actions;
/**********************ACTIONS************************************************ */
export const login =
  (requestParams, navigate, setIsDialogOpen) => async (dispatch) => {
    dispatch(apiFetching());
    axios
      .post(
        `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.login}`,

        requestParams,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_AUTH_API_KEY}`,
          },
        }
      )
      .then((response) => {
        let result = response.data;
        if (
          result.status === API_RESPONSE?.NOTVERIFIED ||
          result.status === API_RESPONSE?.NOTPASSWORD
        ) {
          setIsDialogOpen((isDialogOpen) => ({
            ...isDialogOpen,
            open: true,
            message: result.message,
          }));
        } else if (result.status == API_RESPONSE?.SUCCESS) {
          storeLoggedInUser(result);
          redirectToDashboard();
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

export const checkEmailOrPhoneNumberExistOrNot =
  (requestParams) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.checkEmailOrPhoneNumberExistOrNot}`, requestParams)
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          dispatch(setUserExistingRoles(result));
          return result;
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

export const hideUserEmail =
  (request) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .put(PLAYMATEZAPI.hideUserEmail, request)
      .then((response) => {
        let result = response.data;
        toast.success(result?.message);
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

export const sentOtp = (requestParams, setIsDialogOpen) => async (dispatch) => {
  dispatch(apiFetching());

  // Make sure subType is an array of objects, e.g.:
  // subType: [{ key: "clubs", displayName: "Clubs" }]
  const payload = {
    ...requestParams,
    subType: Array.isArray(requestParams.subType) ? requestParams.subType : [],
  };

  axios
    .post(
      `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.sentOtp}`,
      payload,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_AUTH_API_KEY}`,
        },
      }
    )
    .then((response) => {
      const result = response.data;
      console.log("verify========>", result);
      if (result.status === API_RESPONSE?.SUCCESS) {
        toast.success(result?.message);
        dispatch(setotpToken(result));
        setIsDialogOpen(true);
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

export const verifyOtp =
  (requestParams, afterValidate, closeDialog) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.verifyOtp}`, requestParams)
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          dispatch(setotpToken(result));
          afterValidate();
          closeDialog();
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

  export const registrationUser =
  (requestParams, navigate, setIsDialogOpen) => async (dispatch) => {
    dispatch(apiFetching());
    axios
      .post(
        `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.registrationUser}`,
        requestParams,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_AUTH_API_KEY}`,
          },
        }
      )
      .then((response) => {
        let result = response.data;
        console.log("registration-------------->",result)
        if (result.status === API_RESPONSE?.SUCCESS) {
          navigate("/login");
          toast.success(result?.message);
          setIsDialogOpen(false);
        } else {
          toast.error(result.message);
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };


export const resetPassword = (requestParams, navigate) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(`${PLAYMATEZAPI.resetPassword}`, requestParams)
    .then((response) => {
      let result = response.data;
      if (result.status === API_RESPONSE?.SUCCESS) {
        navigate("/login");
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

export const socialLogin =
  (
    requestParams,
    setUserTypeDialogOpen,
    // verifyPhoneEmail,
    navigate,
    setIsDialogOpen
  ) =>
    async (dispatch) => {
      dispatch(apiFetching());
      api
        .post(`${PLAYMATEZAPI.socialLogin}`, requestParams)
        .then((response) => {
          let result = response.data;
          if (result.status === API_RESPONSE?.SUCCESS) {
            if (requestParams?.userType && requestParams?.userType?.length > 0) {
              storeLoggedInUser(result);
              redirectToDashboard();
            } else {
              dispatch(setUserExistingRoles(result));
              // verifyPhoneEmail();
              setUserTypeDialogOpen(true);
            }
          } else if (
            result.status === API_RESPONSE?.NOTVERIFIED ||
            result.status === API_RESPONSE?.NOTPASSWORD
          ) {
            setIsDialogOpen((isDialogOpen) => ({
              ...isDialogOpen,
              open: true,
              message: result.message,
            }));
          } else {
            toast.error(result.message);
          }
        })
        .catch(() => {
          dispatch(apiFailed());
        });
    };

// change password
export const changePassword =
  (requestParams, handleSuccess) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .put(`${PLAYMATEZAPI.changePassword}`, requestParams)
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          handleSuccess(true);
          toast.success(result.message);
        } else {
          handleSuccess(false);
          toast.error(result.message);
        }
      })
      .catch(() => {
        handleSuccess(false);
        toast.error("Something went wrong!");
        dispatch(apiFailed());
      });
  };

// get config(enums)
export const getConfig = () => async (dispatch) => {
  api
    .get(`${PLAYMATEZAPI.getConfig}`)
    .then((response) => {
      let result = response.data;
      if (result.status === API_RESPONSE?.SUCCESS) {
        dispatch(getConfigSuccess(result.data));
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      toast.error("Something went wrong!");
    });
};

// upload Images
export const uploadImages = (formData, folderName) => async (dispatch) => {
  try {
    const response = await api.post(
      `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.uploadProofImages}/${folderName}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const result = response.data;

    if (result.status === API_RESPONSE.SUCCESS) {
      return result.data; // ✅ THIS WILL RETURN
    } else {
      toast.error(result.message);
      return null;
    }
  } catch (error) {
    toast.error("Something went wrong!");
    return null;
  }
};

// upload user profile pictures
export const userImageUpload =
  (formData, folderName, type) => async (dispatch) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}${PLAYMATEZAPI.userImageUpload}/en/${folderName}/${type}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const result = response.data;

      if (result.status === API_RESPONSE.SUCCESS) {
        return result.data; // ✅ THIS WILL RETURN
      } else {
        toast.error(result.message);
        return null;
      }
    } catch (error) {
      toast.error("Something went wrong!");
      return null;
    }
  };

// delete uploded profile picture image

export const deleteProfileImage = (requestParams) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(`${PLAYMATEZAPI.deleteProfileImage}`, requestParams)
    .then((response) => {
      let result = response.data;
      if (result.status === API_RESPONSE?.SUCCESS) {
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

// get notification list
export const getNotificationList =
  (page, perPage, search, setButtonLoading) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .get(
        `${PLAYMATEZAPI.getNotificationList}?page=${page}&perPage=${perPage}&search=${search}`
      )
      .then((response) => {
        let result = response.data;
        if (result.status === API_RESPONSE?.SUCCESS) {
          dispatch(
            getNotificationListSuccess({
              data: result,
              page: page,
            })
          );
        } else {
          toast.error(result.message);
        }
        setButtonLoading(false);
      })
      .catch(() => {
        setButtonLoading(false);
        dispatch(apiFailed());
      });
  };

// add review rating
export const addRatingReviews =
  (requestParams, setRatingData) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.rating.addRatingReviews, requestParams)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          toast.success(result?.message);
          dispatch(addRatingReviewsSuccess(requestParams?.notificationId));
        } else {
          toast.error(result.message);
        }
        if (setRatingData) {
          setRatingData(() => ({
            loader: false,
          }));
        }
      })
      .catch(() => {
        dispatch(apiFailed());
      });
  };

// get unread notification count
export const getMyUnreadNotification = () => async (dispatch) => {
  api
    .get(PLAYMATEZAPI.countMyUnreadNotification)
    .then((response) => {
      let result = response.data;

      if (result?.status) {
        dispatch(countMyUnreadNotificationSuccess(result));
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

// read Unread Notification
export const readUnreadNotification = (request) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.readUnreadNotification, request)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        dispatch(countMyUnreadNotificationSuccess(null));
      } else {
        toast.error(result.message);
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

// delete Notification
export const deleteNotifications =
  (request, handleSuccess) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.deleteNotifications, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          dispatch(deleteNotificationsSuccess(request?.ids));
          handleSuccess(true);
        } else {
          handleSuccess(false);
          toast.error(result.message);
        }
      })
      .catch(() => {
        handleSuccess(false);
        dispatch(apiFailed());
      });
  };
